import { render, staticRenderFns } from "./Tourist.vue?vue&type=template&id=57273552&scoped=true&"
import script from "./Tourist.vue?vue&type=script&lang=js&"
export * from "./Tourist.vue?vue&type=script&lang=js&"
import style0 from "./Tourist.vue?vue&type=style&index=0&id=57273552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57273552",
  null
  
)

export default component.exports